<template>
  <div class="price-list">
    <div class="discount row-bg-yellow" v-for="(part, index) in feeList" :key="index">
      <span>{{ part.name }} {{ part.quantity && part.quantity >= 2 ? "x" + part.quantity : "" }}</span>
      <span :class="part.color ? part.color : ''" class="bold">NT$ {{ part.price }}</span>
    </div>

    <div class="discount pb-5" v-if="detail && detail.finalPrice">
      <div>總付款金額</div>
      <div class="bold">NT$ {{ detail.finalPrice }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "order-price-list",
  props: {
    detail: { type: Object, default: () => ({}) },
  },
  computed: {
    feeList() { return (this.detail && this.detail.feeList) || []; },
  },
};
</script>

<style lang="less" scoped>
.price-list {
  margin-top: 10px;
  border-top: 0.5px solid #f3f3f3;
  padding-bottom: 10px;

  .discount {
    height: 40px;
    display: flex;
    padding: 5px 10px;
    align-items: center;
    justify-content: space-between;
    &.row-bg-yellow{
      background-color: #FFF3EB;
    }

    > span,
    > div {
      font-size: 14px;
      color: #333;
    }

    .red {
      color: #f63c2c;
    }

    .blue {
      color: #008edc;
    }
  }
}

.bold {
  font-weight: bold;
}

.pb-5 {
  padding-bottom: 5px;
}
</style>
